import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Collapse from 'react-bootstrap/lib/Collapse';

import { Translate, I18n } from 'react-redux-i18n';
import docs from '../ide/docs';

class Toolbox extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.setDragValue = this.setDragValue.bind(this);
    this.list = docs;

    this.toggleCollapse = this.toggleCollapse.bind(this);
    this.state = {
      collapse: {},
      key: Math.random(),
    };
  }

  setDragValue(ev, value) {
    ev.dataTransfer.setData('text', value);
  }

  toggleCollapse(cat) {
    const { collapse } = this.state;
    collapse[cat] = !collapse[cat];
    this.setState({ collapse: collapse, key: Math.random() });
  }

  render() {
    const elements = [];
    for (const key in this.list) {
      if (this.list.hasOwnProperty(key)) {
        const item = this.list[key];
        elements.push(
          <li key={key}>
            <button
              className="btn btn-link"
              id={`btn-cat-${key}`}
              draggable="true"
              onDragStart={e => this.setDragValue(e, key)}
              onClick={() => this.toggleCollapse(key)}
            >
              {key}
            </button>
            <Collapse
              id={`cat-${key}`}
              in={this.state.collapse[key]}
              aria-labelledby={`btn-cat-${key}`}
            >
              <ul>
                {item.map((sub, index) => (
                  <li
                    key={`sub_${index}`}
                    draggable="true"
                    onDragStart={e =>
                      this.setDragValue(e, `${key}.${sub.text}\n`)
                    }
                    className="highlight"
                  >
                    <h5> {sub.text} </h5>
                    {sub.tooltip &&
                      I18n.t(`gui.toolbox.${key}.${sub.tooltip}`)
                        .split('<br />')
                        .map(x => (
                          <React.Fragment key={x}>
                            {x}
                            <br />
                          </React.Fragment>
                        ))}
                  </li>
                ))}
              </ul>
            </Collapse>
          </li>
        );
      }
    }

    return (
      <div
        className={this.props.toggled ? 'col-xs-3' : ''}
        style={{
          height: '100%',
          overflow: 'auto',
          float: 'left',
          paddingRight: 0,
          backgroundColor: '#F2F2F2',
        }}
      >
        <div
          style={{ overflowX: 'hidden', paddingLeft: '5px' }}
          className={this.props.toggled ? '' : 'hidden'}
        >
          <h4>Информация</h4>
          <nav>
            <ul>
              <li>
                <button className="btn btn-link" onClick={this.props.openModal}>
                  Примеры проектов
                </button>
              </li>
            </ul>
          </nav>

          <h4>
            <Translate value="gui.toolbox.documentation" />
          </h4>
          <nav>
            <ul className="nav">{elements}</ul>
          </nav>
        </div>
      </div>
    );
  }
}

Toolbox.propTypes = {
  toggled: PropTypes.bool,
  openModal: PropTypes.func,
};

Toolbox.defaultProps = {
  toggled: false,
};

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps)(Toolbox);
